import { createContext, useContext, useEffect, useState } from "react";
import { DICT } from "@/lib/i18n";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("hsps_lang") || "en");
  useEffect(() => {
    localStorage.setItem("hsps_lang", lang);
    document.documentElement.lang = lang;
    // Devanagari script for both hi and hr
    document.documentElement.classList.toggle("lang-hi", lang === "hi" || lang === "hr");
  }, [lang]);
  const t = (key) => DICT[lang]?.[key] ?? DICT.en[key] ?? key;
  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
